import React from "react"
import { Panel } from "react-bootstrap"
import { withRouter } from "react-router-dom"

import { getUiState, setUiState } from "@/_services/uiState"
import { getUserConfiguration } from "@/_services/userConfiguration"
import { localStorageKeys } from "@/_services/utils"

class PanelOuter extends React.Component {
  constructor(props) {
    super(props)

    this.panelOuterRef = React.createRef()
    this.state = {
      saveOuterPanelsExpandedState: getUserConfiguration()?.options?.saveOuterPanelsExpandedState === true,
    }
  }

  componentDidMount() {
    const { saveOuterPanelsExpandedState } = this.state
    const { expanded } = this.props

    if (!saveOuterPanelsExpandedState) return this.setState({ isExpanded: expanded })

    const { onToggle } = this.props
    const expandedFlag = this.getExpandedFromUiState()
    if (onToggle && expandedFlag !== undefined && expanded !== expandedFlag) onToggle()
  }

  componentDidUpdate() {
    const { isExpanded, saveOuterPanelsExpandedState } = this.state
    const { expanded } = this.props

    if (expanded !== isExpanded) {
      this.setState({ isExpanded: expanded }, () => saveOuterPanelsExpandedState && this.setExpandedInUiState(expanded))
    }
  }

  getExpandedFromUiState = () => {
    const {
      modelFieldPath = "",
      match: { path },
      cardTitle,
    } = this.props

    // We rely on the translated card title and its eventual modelFieldPath.
    // This means that changing language does not preserve state, and we hope that nobody configure cards with the title and modelFieldPath.
    // Before that, we used to use the DOM path to the element (like a XPath) but it was inconsistent due to the multiple layout renders.
    // Depending on the render speed of cards, they could have a different XPath between each page load.
    // Creating a special algorithm to handle that was overkill.
    const panelPseudoId = (cardTitle && typeof cardTitle === "string" ? cardTitle : "") + (modelFieldPath ? `>${modelFieldPath}` : "")
    if (panelPseudoId) {
      this.setState({ panelPseudoId })
      return getUiState(`${localStorageKeys.UI_STATE.PANELS_PREFIX}${path}.outer[${panelPseudoId}].isExpanded`)
    }
  }

  setExpandedInUiState = isExpanded => {
    const {
      match: { path },
    } = this.props
    const { panelPseudoId } = this.state

    if (panelPseudoId) {
      setUiState(`${localStorageKeys.UI_STATE.PANELS_PREFIX}${path}.outer[${panelPseudoId}].isExpanded`, isExpanded)
    }
  }

  render() {
    const { children, onToggle } = this.props
    const { isExpanded } = this.state

    return (
      <>
        {/* 
          We need to put the ref on another element because the bootstrap Panel component doesn't forward refs.
          Another possible technique is to create a unique attribute in the Panel component and use it to find the element in the DOM
          once it is mounted but it requires additional work.
        */}
        <span style={{ display: "none" }} ref={this.panelOuterRef}></span>
        <Panel expanded={isExpanded} onToggle={onToggle} className="panel-outer">
          {/* 
            when the isExpanded is not yet assigned, don't display anything 
            to avoid an initial flickering between the local storage state and the one provided in the props
          */}
          {isExpanded !== undefined && (
            <Panel.Collapse>
              <Panel.Body>{children}</Panel.Body>
            </Panel.Collapse>
          )}
        </Panel>
      </>
    )
  }
}

export default withRouter(PanelOuter)
